export const selectUser = state => state.user;

export const selectIsLoadingUser = state => state.user.isLoading;

export const selectTheme = state => state.user.theme;
